import React, { useEffect, useState, useRef } from 'react';
import { Grid } from '@mui/material';
import DataTable from '../../../components/DataTable';
import { format } from 'date-fns';
import enUSLocale from 'date-fns/locale/en-US';
import { Button } from "react-bootstrap";
import { tokenRequest } from "../../../auth/authConfig";
import { useAuthorization } from "../../../hooks/useAuthorization";
import { useAccount, useMsal } from "@azure/msal-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useNavigationParameters } from "../../../hooks/useNavigationParameters";
import * as Constants from "../../../helper/constants";
import appconfig from '../../../appConfig'

export default function ClientGatewayTable(props) {

    const [canCreate, canRead, canUpdate, canDelete] = useAuthorization();
    const [appendExistingNavigationParameters,  removeDuplicatedNavigationParameters , prepareNavigationParameters] = useNavigationParameters();
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});
    const navigate = useNavigate();
    const urlToCreateClientGateway = appconfig.URL_TO_CREATE_CLIENT_GATEWAY;
    const urlToUpdateClientGateway = appconfig.URL_TO_UPDATE_CLIENT_GATEWAY;
    const urlToReadonlyClientGateway = appconfig.URL_TO_READONLY_CLIENT_GATEWAY;

    const columnHeaders = [
    { field: 'id', width: 180, headerName: 'Client Gateway Form Id', editable: false, renderCell: true, hide: true},
    { field: 'formStatus', width: 150, headerName: 'Form Status', editable: false },
    { field: 'docket', width: 150, headerName: 'Docket', editable: false },
    { field: 'inCustody', width: 150, headerName: 'In Custody', editable: false },
    { field: 'nextCourtDate', type: 'date', width: 150, headerName: 'Next Court Date', renderDate: true, editable: false },
    { field: 'courtLocation', width: 350, headerName: 'Court Location', editable: false },
    { field: 'likelihoodOfImprisonment', width: 200, headerName: 'Likelihood of Imprisonment', editable: false }

    ];
    const columns = [];
    columnHeaders.forEach((columnHeader) => {
        columns.push(
            {
                field: columnHeader.field,
                renderHeader: () => (<div style={{ font: 'normal normal normal 15px/16px Franklin Gothic Medium', color: "#000000" }}>{columnHeader.headerName}</div>),
                renderCell: columnHeader.renderDate ? (params) => <>{params.value != null ? format(new Date(params.value), 'dd-MMM-yyyy') : null}  </> : columnHeader.renderCell ? (params) => (<a href={`${prepareNavigationParameters(Constants.CLIENTGATEWAY, new Array(params.value.split("-")[1],props.clientFileId) , null, "page=clientfile")}`}>{params.value}</a>) : null,
                width: columnHeader.width,
                editable: columnHeader.editable,
                hide: columnHeader.hide
            },
        );
    });

    const rows = [];
    if (props.clientGatewayDetails && props.clientGatewayDetails.length > 0) {
        props.clientGatewayDetails.forEach((clientGatewayDetail) => {
            rows.push(
                {
                    id: clientGatewayDetail.id,
                    formStatus: clientGatewayDetail.formStatus,
                    docket: clientGatewayDetail.docket,
                    inCustody: clientGatewayDetail.inCustody,
                    nextCourtDate: clientGatewayDetail.nextCourtDate != null ? clientGatewayDetail.nextCourtDate : null,
                    courtLocation: clientGatewayDetail.courtLocation,
                    likelihoodOfImprisonment: clientGatewayDetail.likelihoodOfImprisonment,
                    externalReferenceId: clientGatewayDetail.externalReferenceId
                },
            );
        });
    };

    function getUrlForNewClientGateway() {
        const queryString = new URLSearchParams();
        queryString.set('clientFirstName', `${props.clientFirstName}`);
        queryString.append('clientLastName', `${props.clientLastName}`);
        queryString.append('clientDateOfBirth', `${format(new Date(props.clientDateOfBirth),  'P', { locale: enUSLocale })}`);
        queryString.append('clientPhoneNumber', `${props.clientPhoneNumber}`);
        queryString.append('clientEmail', `${props.clientEmail}`);
        queryString.append('laa_DCPortalClientFileID', `${props.clientFileId}`);
        queryString.append('clientMobileNumber', `${props.clientMobileNumber}`);

        const url = `${urlToCreateClientGateway}?${queryString}`;

        return url;
    };

    function getUrlForExistingClientGateway(row) {
        const queryString = new URLSearchParams();
        queryString.set('id', `${row.externalReferenceId}`);
        const status = row.formStatus;

        if(status){
            if(status.toUpperCase() === 'DRAFT'){
                const url = `${urlToUpdateClientGateway}?${queryString}`;
                return url;
            }
            else {
                const url = `${urlToReadonlyClientGateway}?${queryString}`;
                return url;
            }

        }
        else {
            const url = `${urlToReadonlyClientGateway}?${queryString}`;
            return url;
        }
    };

    const onRowClicked = (item) => {
        const isNotLegacy = item.row.externalReferenceId;

        if(isNotLegacy) {
            const url = getUrlForExistingClientGateway(item.row);    
            window.open(url, '_blank').focus();
        }
        else {
            navigate(`${prepareNavigationParameters(Constants.CLIENTGATEWAY, new Array(item.row.id.split("-")[1],props.clientFileId) , null, "page=clientfile")}`);   
        }      
    };

    const createNewClientGateway = () => {
        // size="sm" variant={(canCreate("client-gateway", null)) ? "primary" : "secondary"} disabled={(canCreate("client-gateway", null)) ? "" : "disabled"} className="ml-auto" href={`${prepareNavigationParameters(Constants.CLIENTGATEWAY, new Array(null,props.clientFileId) , null, "page=clientfile")}`}>New Client Gateway</Button>

        navigate(`${prepareNavigationParameters(Constants.CLIENTGATEWAY, new Array(null,props.clientFileId) , null, "page=clientfile")}`);
    }

    if (props.clientFileId && props.clientFileId > 0) {
        return (
            <Grid container style={{ padding: "10px 20px 20px 20px", backgroundColor: props.isReadOnly ? "#ececec" : null }}>
                <Grid item xs={12} md={12} style={{
                    textAlign: "left", font: "normal normal normal 17px/22px Franklin Gothic Medium",
                    letterSpacing: "0px", color: " #000000", opacity: "1", marginBottom: "25px"
                }}>{props.title}
                    {canCreate("client-gateway", null) && <Button style={{ font: "normal normal normal 15px/24px Franklin Gothic Medium", backgroundColor: "#D41F44", borderColor: "#D41F44", position: "absolute", right: "40px" }}
                        size="sm" variant={(canCreate("client-gateway", null)) ? "primary" : "secondary"} disabled={(canCreate("client-gateway", null)) ? "" : "disabled"} className="ml-auto" onClick={createNewClientGateway}>New Client Gateway</Button>
                    }</Grid>
                <DataTable columns={columns} rows={rows} onRowDoubleClick={onRowClicked}/>
            </Grid>
        );
    }

};
